<template>
  <div>
    <span v-if="loading">Loading target...</span>
    <span v-else>
      <TargetCircles :target="getTarget" />
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import authMixin from "@/mixins/authMixin";
import { SET_TARGET } from "../../store/mutation-types";
import TargetCircles from "./TargetCircles";

export default {
  components: { TargetCircles },
  mixins: [authMixin],
  computed: {
    ...mapGetters(["getTarget"]),
    loading() {
      return this.getTarget.targetDailyRecordings === undefined;
    }
  },
  methods: {
    ...mapActions(["fetchTarget"]),
    async initialize() {
      if (this.getTarget.targetDailyRecordings === undefined) {
        if (this.oidcIsAuthenticated) await this.fetchTarget();
        // default target for anonymous users
        else
          this.$store.commit(SET_TARGET, {
            targetDailyRecordings: 3,
            currentDailyRecordings: 0,
            targetDailySeconds: 60,
            currentDailySeconds: 0,
            targetDailySpellings: 10,
            currentDailySpellings: 0
          });
      }
    }
  },
  async created() {
    let unsubscribe = null;
    unsubscribe = this.$store.subscribe(async ({ type }) => {
      if (type === "setOidcAuthIsChecked") {
        await this.initialize();
        unsubscribe(); // So it only reacts once.
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
